var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { StyledButton } from '../../../Components/CurrencyInput';
import { MetaMaskIcon } from './mm';
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import styled from 'styled-components';
import { changeActiveChain, getAccount, } from '../../../../Services/ETHExtensionUtils';
import { useAnalytics } from '../../../Contexts/AnalyticsContext';
import { ZeroIdAgreement } from '../ZeroId/ZeroIdAgreement';
var BtnWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  right: 10px;\n  top: 14px;\n"], ["\n  position: absolute;\n  right: 10px;\n  top: 14px;\n"])));
export function useMetaMask(_a) {
    var _this = this;
    var _b;
    var onSuccess = _a.onSuccess, onError = _a.onError, currency = _a.currency, address = _a.address;
    var _c = React.useState(localStorage.getItem('address_from_mm') || undefined), metaMaskAddress = _c[0], setMetaMaskAddress = _c[1];
    var wasAttemptedToImportMetaMask = useRef(Boolean(address));
    var track = useAnalytics().track;
    var isEVM = Array.isArray(currency === null || currency === void 0 ? void 0 : currency.capabilities)
        ? currency.capabilities.includes('EVM')
        : Boolean((_b = currency === null || currency === void 0 ? void 0 : currency.capabilities) === null || _b === void 0 ? void 0 : _b.evm);
    var isMetaMask = useMemo(function () {
        var _a;
        return Boolean((_a = window.ethereum) === null || _a === void 0 ? void 0 : _a.isMetaMask);
    }, []);
    var isZeroIdExist = Boolean(localStorage.getItem('ZERO_ID_ISSUED_BY_ORDER_ID'));
    var isSupported = useMemo(function () { return isMetaMask && isEVM; }, [isMetaMask, isEVM]);
    var shouldMintZeroId = useMemo(function () { return isSupported && !isZeroIdExist; }, [isSupported, isZeroIdExist]);
    var _d = React.useState(shouldMintZeroId), issueZeroId = _d[0], setIssueZeroId = _d[1];
    var _e = React.useState(false), possibleIssueZeroId = _e[0], setPossibleIssueZeroId = _e[1];
    var getAddress = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            track('wallet_metamask_import_requested');
            return [2 /*return*/, new Promise(function (resolve) {
                    var chainId = currency.capabilities &&
                        'evmChainId' in currency.capabilities &&
                        currency.capabilities.evmChainId;
                    if (!chainId) {
                        resolve();
                    }
                    else {
                        changeActiveChain(chainId).finally(resolve);
                    }
                })
                    .then(getAccount)
                    .then(function (a) {
                    track('wallet_metamask_import_succeed', { wallet_address_metamask: a });
                    localStorage.setItem('address_from_mm', a);
                    setMetaMaskAddress(a);
                    setPossibleIssueZeroId(true);
                    onSuccess(a);
                })
                    .catch(function () {
                    track('wallet_metamask_import_rejected');
                    onError("Sorry, we couldn't get the address");
                })];
        });
    }); }, [currency.capabilities, onError, onSuccess, track]);
    useEffect(function () {
        if (!address && isSupported && !wasAttemptedToImportMetaMask.current) {
            wasAttemptedToImportMetaMask.current = true;
            getAddress();
        }
    }, [address, getAddress, isSupported, track]);
    useEffect(function () {
        setPossibleIssueZeroId(address === metaMaskAddress);
    }, [address, metaMaskAddress]);
    var ExtensionBtn = useCallback(function () {
        return (_jsx(_Fragment, { children: isSupported && (_jsx(BtnWrapper, { children: _jsx(StyledButton, __assign({ onClick: getAddress }, { children: _jsx(MetaMaskIcon, {}) })) })) }));
    }, [isSupported, getAddress]);
    var ZeroIdAgreementBlock = useCallback(function () {
        return (_jsx(_Fragment, { children: shouldMintZeroId && possibleIssueZeroId && (_jsx(ZeroIdAgreement, { onCheck: function () {
                    return setIssueZeroId(function (v) {
                        track("User ".concat(!v ? 'checked' : 'unchecked', " issue ZeroId agreement"));
                        return !v;
                    });
                }, enabled: issueZeroId })) }));
    }, [issueZeroId, possibleIssueZeroId, shouldMintZeroId, track]);
    return {
        ExtensionBtn: ExtensionBtn,
        getAddress: getAddress,
        metaMaskAddress: metaMaskAddress,
        ZeroIdAgreementBlock: ZeroIdAgreementBlock,
        issueZeroId: issueZeroId && possibleIssueZeroId,
    };
}
var templateObject_1;
